var map = {
	"./Admin.vue": [
		"3530",
		"chunk-60a60df6",
		"chunk-3a47cd1c",
		"chunk-cf77c98a"
	],
	"./Home.vue": [
		"bb51",
		"chunk-60a60df6",
		"chunk-33f19ca8",
		"chunk-0e6f4412"
	],
	"./Inventory.vue": [
		"e25f",
		"chunk-60a60df6",
		"chunk-3a47cd1c",
		"chunk-c89b5a7e"
	],
	"./Login.vue": [
		"a55b",
		"chunk-2dc6014c"
	],
	"./Orders.vue": [
		"159d",
		"chunk-33f19ca8",
		"chunk-f85de07e",
		"chunk-694faf6a"
	],
	"./Reports.vue": [
		"c11b",
		"chunk-60a60df6",
		"chunk-33f19ca8",
		"chunk-3a47cd1c",
		"chunk-3fe57a81"
	],
	"./Services.vue": [
		"f23e",
		"chunk-60a60df6",
		"chunk-33f19ca8",
		"chunk-3a47cd1c",
		"chunk-f85de07e",
		"chunk-acd9ff8a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;